import {
    Flex,
    Text,
    Box,
    Input,
    MenuItem,
    Menu,
    MenuButton,
    MenuList,
    Button,
    Image
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import useApp from '../context/AppContext'
import Player from './Player'

function Home() {

    const {players, soldPlayers, teams, latestSell, reservedPlayers, catogories} = useApp()
    const [show, setShow] = useState([])
    const [identifier, setIdentifier] = useState('Player name')
    const [search, setSearch] = useState("")
    const isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(navigator.userAgent)) ? true : false;
   
    const identifiers = [
        'Player name',
        'member ID',
        'number'
    ]

    const scroll = (e) => {
        if(isMobile)
        {
            const m = document.getElementById('input')
            // console.log(m.offsetTop)
            setTimeout(() => 
            window.scrollTo(0, m.offsetTop-10)
            ,100)
        }
    }

    useEffect(() => {

        let id;
        if(identifier === 'member ID')
            id = 'mid'
        else if(identifier === 'Player name')
            id='p_name'
        else
            id='number'

        const func = async () => {

            if(id === 'number')
            {
                setShow(players.list.filter(p => players.players[p].num.toLowerCase().includes(search.toLowerCase())))
            }
            if(id === 'mid')
            {
                setShow(players.list.filter(p => players?.players[p]?.mid?.toLowerCase().includes(search.toLowerCase())))
            }
            if(id === 'p_name')
            {
                setShow(players.list.filter(p => players?.players[p]?.name?.toLowerCase().includes(search.toLowerCase())))
            }
        }

        if(search && search.length > 0)
            func()
        else
            setShow([...players?.list])
        
    }, [search])

    return (
        <Flex
            direction={'column'}
            py={5}
        >
            <Text
                textAlign={'center'}
                fontSize={'32px'}
                fontWeight={600}
            >THE CITY CENTER CUP 2025</Text>

            <Flex
                w={'90%'}
                h={200}
                mx={'auto'}
                my={2}
                boxShadow={'xl'}
                border="1px"
                borderColor={'gray.700'}
                borderRadius={10}
                px={2}
                py={5}
            >
                {latestSell?
                <>
                <Flex
                    w={'50%'}
                    direction={'column'}
                    gap={5}
                >
                    <Box>
                        <Text>
                            {players?.players[latestSell?.pid]?.name}
                        </Text>
                        <Text>
                            {players?.players[latestSell?.pid]?.category}
                        </Text>
                        <Text>
                            {players?.players[latestSell?.pid]?.type}
                        </Text>
                    </Box>
                    <Box>
                        <Text>
                            Sold To:
                        </Text>
                        <Text fontWeight={600}>
                            {teams?.teams[latestSell?.tid]?.name}
                        </Text>
                        <Text fontWeight={600}>
                            {latestSell?.cost} Points
                        </Text>
                    </Box>

                
                </Flex>

                <Flex
                    w={'50%'}
                    borderRadius={10}
                    // border={'1px'}
                    overflow={'hidden'}
                    // borderColor={'gray.700'}
                    // boxShadow={'xl'}
                >
                    <Image
                        w={'100%'}
                        alt="Pic Not Available"
                        h={'auto'}
                        border={0}
                        objectFit="contain"
                    src={players?.players[latestSell?.pid]?.image}/>
                </Flex>

                </>:"Auction hasn't Started Yet"
            }

            </Flex>

            {/* {players.length>0?players.map(data => <Player data={data}/>):<></>} */}

            <Flex
                px = {5}
                gap={2}
                justifyContent={'center'}
                mt={5}
            >
                <Input w={'70%'}
                    id={'input'}
                    value={search}
                    placeholder={`Search using ${identifier}`}
                    onChange = {e => setSearch(e.target.value)}
                    onFocus={(e) => scroll(e)}
                />
                
                <Menu>
                    <MenuButton as={Button} >
                        {identifier}
                    </MenuButton>

                    <MenuList>
                        {identifiers.map(t => 
                            <MenuItem key={t} onClick={() => setIdentifier(t)}>{t}</MenuItem>
                        )}
                    </MenuList>

                </Menu>
            </Flex>
                            
            <Flex
                direction={'column'}
                gap={3}
                px={5}
                mt={5}

            >
            {show.map(p => {
                
                if(catogories.filter(c => c === players.players[p].category).length === 0)
                    return <></>
                const play = soldPlayers.filter(s => s.pid === p)[0]
                const reserve = reservedPlayers.filter(r => r.pid === p)[0]
                return (
                    <Flex 
                        w={'full'}
                        alignItems={'center'}
                        gap={2}
                    >
                        <Text>{players.players[p].num}</Text>
                        <Player data={players.players[p]} sold={play?play:null} reserved={reserve?reserve:null}/>
                    </Flex>
                )}
            
            )}
            
            </Flex>
        </Flex>
    )
}

export default Home
